import { useConfigurationStore } from "@/store/configuration.js"

export const setPageTitle = (title, { appendCommunityInfo } = {}) => {
  const configurationStore = useConfigurationStore()
  if (!title) {
    document.title = configurationStore.configuration.artistLongName || "Disciple PWA"

    return
  }

  if (appendCommunityInfo) {
    const pageTitleParts = [title, `The ${configurationStore.configuration.artistLongName} community`]

    if (!configurationStore.configuration.whiteLabel) {
      pageTitleParts.push("powered by Disciple")
    }

    document.title = pageTitleParts.join(" · ")
  } else {
    document.title = title
  }
}

export const setPageDescription = (description = "", { useColonBeforeCommunityDescription } = {}) => {
  const configurationStore = useConfigurationStore()

  const descriptionMetaTag = document.querySelector('meta[name="description"]')
  const stringBeforeCommunityDescription = useColonBeforeCommunityDescription ? " : " : " - "
  const communityDescription = configurationStore.configuration.registrationPageIntroduction

  if (description && communityDescription) {
    description += `${stringBeforeCommunityDescription}${communityDescription}`
  }

  if (!descriptionMetaTag) {
    const descriptionTag = document.createElement("meta")
    descriptionTag.name = "description"
    descriptionTag.setAttribute("content", description)
    document.head.appendChild(descriptionTag)
  } else {
    document.querySelector('meta[name="description"]').setAttribute("content", description)
  }
}
